/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPharmacySuppliers } from 'app/shared/model/pharmacy-suppliers.model';
import { IPharmacy } from 'app/shared/model/pharmacy.model';

export interface IPharmacySupplierAttribute {
  id?: string;
  active?: boolean;
  lastUpdated?: number;
  timestampEntry?: number;
  microSec?: number;
  cursor?: number;
  key?: string | null;
  value?: string | null;
  comments?: string | null;
  pharmacySuppliers?: IPharmacySuppliers | null;
  pharmacy?: IPharmacy | null;
}

export const defaultValue: Readonly<IPharmacySupplierAttribute> = {
  active: false,
};
